<template>
  <component class="DutiesHeader" :moduleConfig="mx_moduleConfig" :is="headerComponent"></component>
</template>

<script>
import DutyListHeader from '@/modules/myDuties/headers/DutyListHeader.vue';
import DutiesHeaderSplitView from '@/modules/myDuties/headers/DutiesHeaderSplitView.vue';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';

const flavourComponentMapping = { DutyCalendarRhbStyle: 'DutiesHeaderSplitView', DutyList: 'DutyListHeader' };

export default {
  name: 'DutiesHeader',
  mixins: [dutyMixin],
  components: { DutyListHeader, DutiesHeaderSplitView },
  mounted() {
    console.debug('DutiesHeader with', this.mx_moduleFlavour);
  },
  computed: {
    headerComponent() {
      return flavourComponentMapping[this.mx_moduleFlavour];
    },
  },
};
</script>
